import React from 'react';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';
export function TermsOfServicePage() {
  return <main data-id="element-572">
      <SEO title="Terms of Service" description="Terms of Service for Ambient Solutions LLC." data-id="element-573" />
      <PageHero title="Terms of Service" subtitle="The terms and conditions for using our website and services" data-id="element-574" />

      <section className="py-20 px-4 bg-white" data-id="element-575">
        <div className="max-w-3xl mx-auto prose prose-neutral" data-id="element-576">
          <p className="text-neutral-medium mb-8" data-id="element-577">Last Updated: May 2026</p>

          <div className="space-y-12" data-id="element-578">
            <div data-id="element-579">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-580">
                1. Acceptance of Terms
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-581">
                By accessing or using the Ambient Solutions LLC website and
                services, you agree to be bound by these Terms of Service and
                all applicable laws and regulations. If you do not agree with
                any of these terms, you are prohibited from using or accessing
                this site.
              </p>
            </div>

            <div data-id="element-582">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-583">
                2. Use of Services
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-584">
                Our services include helping families hire, train, and certify
                loved ones as professional caregivers. Use of these services is
                subject to specific service agreements, background check
                approvals, and compliance with state and federal healthcare
                regulations.
              </p>
            </div>

            <div data-id="element-585">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-586">
                3. Caregiver Certification
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-587">
                While we facilitate the training and certification process,
                approval is subject to mandatory background checks, successful
                completion of training modules, and regulatory compliance. We
                reserve the right to deny certification based on these criteria.
              </p>
            </div>

            <div data-id="element-588">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-589">
                4. Disclaimer
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-590">
                The materials on our website are provided on an 'as is' basis.
                Ambient Solutions LLC makes no warranties, expressed or implied,
                and hereby disclaims and negates all other warranties including,
                without limitation, implied warranties or conditions of
                merchantability, fitness for a particular purpose, or
                non-infringement of intellectual property or other violation of
                rights.
              </p>
            </div>

            <div data-id="element-591">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-592">
                5. Governing Law
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-593">
                These terms and conditions are governed by and construed in
                accordance with the laws of the State of Maryland and you
                irrevocably submit to the exclusive jurisdiction of the courts
                in that State.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}